import makeStyles from '@mui/styles/makeStyles';

import { INTERCOM_Z_INDEX } from '../../services/intercom/useIntercom';

/**
 * Lifts ui-library's `z-50` body portals over this host's 200 wrapper, only while the new sidebar
 * is mounted. The sub-navigation panel portals at 1301, above MFE overlays, so do not widen the
 * selector to catch it (AGENTS.md, Stacking).
 */
const useNewSidebarPortalStyles = makeStyles({
  '@global': {
    'body > [data-tailwind].z-50': {
      zIndex: 200,
    },
    // Intercom's banner frame ignores the `z_index` setting (at boot and via `update`) and keeps
    // the maximum z-index from Intercom's own stylesheet, so it covered the mobile drawer. Its
    // z-index is not inline, so this wins. Delete once Portal renders the banner itself.
    'iframe[name="intercom-banner-frame"]': {
      zIndex: `${INTERCOM_Z_INDEX} !important`,
    },
  },
});

const NewSidebarPortalStyles = () => {
  useNewSidebarPortalStyles();
  return null;
};

export default NewSidebarPortalStyles;
